
import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
//---------- TOUCH EVENTS --------------------------------------//
import '@benmajor/jquery-touch-events';

export default class{ // export class Layout
    
    constructor(options) {

    	// OPTIONS
        this.defaults = {
        	main: undefined,
        	skip_intro: false
        }

        this.options = {};
		Object.assign(this.options, this.defaults, options);
        this.namespace 	= 'layout';

		this.main 		= this.options.main;

        // VARS
		this.$window 	= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $('body');

		this.init()

    }

 	init() {

 		this.initIntro();

 		this.initAnnouncementBar();

		this.debounceResize(true);
		
		this.initMainMenu();

		this.changePageTitle();

		this.initLawns();

		// this.paintMenu( document.location.href );

		this.initMobile();

		this.checkHash();

		setTimeout( ()=>this.onResize(), 277 );

    }

    initIntro(){
    	let $intro = $('#intro-animation'), $scroll = $intro.find( '.size-hero-home' );
    	if ( $intro.length > 0 ){
    		if ( this.options.skip_intro ){
    			$intro.remove();
    			this.$html.removeClass( 'has-intro-animation' );
    			return;
    		}

    		gsap.set( $(window), { scrollTo: 0 });

			disableBodyScroll( $scroll[0] );

			// date intro
			gsap.to( $intro, { opacity:0, ease:'linear', duration: 1, delay: 0.8, onComplete:()=>{
				
				$intro.remove();

				// fade logo
				gsap.to( $('.video-container-home .logo-intro-animation'), {opacity:0, duration:0.6, delay:0.4, ease:'linear', 

					onStart:()=>{
						//this.$html.addClass( 'fade-overlay-message-simultanly' );
					},

					onComplete:()=>{
						enableBodyScroll( $scroll[0] );
						setTimeout( ()=>this.$html.removeClass( 'has-intro-animation' ), 17 );
					}

				});
				
			}});
    	}
    }

    initAnnouncementBar(){
    	let $el = $('#announcement-bar');
    	if ( $el.length > 0 ){
    		$el.find('.close').on( 'click', ()=>this.closeAnnouncementBar() );
    	}
    }

    closeAnnouncementBar(){
    	let $el = $('#announcement-bar');
    	$el.find('.close').off( 'click', ()=>this.closeAnnouncementBar() );
    	gsap.to ( $el, {height:1, opacity:0.3, ease:'power1.out', duration:0.3, onComplete:()=>{
    		
    		$el.remove();
    		this.$html.removeClass( 'has-announcement-bar ' );
    		this.$window.trigger( 'resize' );

    		this.main.EFFEX.reset();

    	}})
    }

    changePageTitle(){
    	let $h1 = $( '#hidden-page-title' ), txt = '';
    	if ( $h1.length > 0 ){
    		txt = $h1.html();
    	}
    	$( '#compact-nav .title' ).html( txt );
    }

    // -----------------------------------------------------------------[ RESIZE HANDLER ]--------------------------------------------------------------//
    debounceResize(b){
      if ( b ){
        // debounce resize
        this._debResize = _debounce( () => this.onResize(), 77 );
        this.$window.on( 'resize', this._debResize );
		// Listen for orientation changes
		window.addEventListener("orientationchange", ()=> this.onOrientationChange(), false);
      }
      else{
        if ( this._debResize ){
          this._debResize.cancel();
          this.$window.off( 'resize', this._debResize );
        }        
		// Listen for orientation changes
		window.removeEventListener("orientationchange", ()=> this.onOrientationChange(), false);
      }
    }

    onOrientationChange(){
    	//console.log( 'onOrientationChange');
    	setTimeout( ()=>this.onResize(), 177 );
    }

	onResize(){

		// this class is used for layouts that need to be resized before revealed. For example .home-MAIN-promo (opacity=0 and resized opacity 1)
		this.$body.addClass( 'resized' );

		// special cases
		/*
		if ( this.$body.hasClass( 'home' ) ){
			
		}
		else{
		}
		*/

		this.openDrawerMobile( false )
	}

	initMainMenu(){
		let $lawn = $('#desktop-header .widget-weather a'), $burger = $('#burger'), $dim = $('#dim-layer'), $drawer = $( '#drawer' ), $closed = $('#drawer .close'), $closew = $('#drawer-lawns .close');
		$lawn.on( 'click', (e)=>{
			e.preventDefault();
			this.openLawns( true );
		});
		$closew.on( 'click', ()=>{
			this.openLawns( false );
		});

		if ( $drawer.hasClass( 'open-on-rollover' ) ){
			$burger.on( 'mouseover', ()=>{
				this.openDrawer( true );
			});
			$drawer.on( 'mouseleave', ()=> {
				this.openDrawer( false );
			});
		}
		else{
			$burger.on( 'click', ()=>{
				this.openDrawer( true );
			});
			$closed.on( 'click', ()=>{
				this.openDrawer( false );
			});

		}

		$dim.on( 'click', ()=>{
			this.openDrawer( false );
			this.openLawns( false );
		});
		this.initSearch();
	}

	openDrawer( b ){
		if ( b ){
			if ( !this.$body.hasClass( 'drawer-open') ){
				this.$body.addClass( 'drawer-open' );
				disableBodyScroll( $('#drawer .scroll-drawer')[0] );
			}
		}
		else{
			if ( this.$body.hasClass( 'drawer-open') ){
				this.$body.removeClass( 'drawer-open' );
				enableBodyScroll( $('#drawer .scroll-drawer')[0] );
			}
		}
	}

	initLawns(){
		// set map colors for lawns open
		let $map = $('#drawer-lawns .map'),
		lawns 	= [ 'elm', 'cherry', 'veterans', 'oval', 'sol_lewitt', 'sparrow', 'redbud', 'farrugat' ], svg, i, $lawn, lawn, open;
		if ( $map.length > 0 ){
			svg = $map.find( 'svg' );
			if ( svg.length > 0 ){
				for( i=0; i<lawns.length; i++ ){
					lawn = lawns[i];
					$lawn = [];
					
					$lawn = svg.find( '#' + lawn );

					// now we inject the svg with unique id, so we have to find which correspond ...
					/*
					svg.find( 'path' ).each( (i, el) => {
						if ( $(el).attr( 'id' ) ){
							if ( $(el).attr( 'id' ).indexOf( lawn ) !== -1 ){
								$lawn = $(el);
							}
						}
					});
					*/

					open = $map.attr( 'data-' + lawn );

					if ( $lawn.length > 0 ){
						$lawn.css({
							fill: open === 'yes' ? '#C2CD3D' : '#8D9B73'
						})						
					}

				}
			}
		}

	}

	openLawns( b ){
		if ( b ){
			if ( !this.$body.hasClass( 'drawer-lawns-open') ){
				this.$body.addClass( 'drawer-lawns-open' );
				disableBodyScroll( $('#drawer-lawns .scroll-drawer')[0] );

				this.main.setGAEvent( 'Lawns Open', 'click' )
			}
		}
		else{
			if ( this.$body.hasClass( 'drawer-lawns-open') ){
				this.$body.removeClass( 'drawer-lawns-open' );
				enableBodyScroll( $('#drawer-lawns .scroll-drawer')[0] );
			}
		}
	}

	initSearch(){
		let $drawer = $('#drawer'), $s = $drawer.find('.search'), $input = $drawer.find('.searchfield');
		$s.on( 'click', ()=>{
			if ( ! $drawer.hasClass( 'activate-search' ) ){
				$drawer.addClass( 'activate-search' );
				$input.focus();				
			}
			else{
				if ( $input.val() ){
					$input.parents( '.searchform' ).submit();
				}
				else{
					$drawer.removeClass( 'activate-search' );
				}
			}
		});
		if ( !$drawer.hasClass( 'open-on-rollover' ) ){ 
			$input.on( 'blur', ()=>{
				$drawer.removeClass( 'activate-search' );
			})
		}
		
	}

	paintMenu( url ){
		let menus = [$('#menu-main-menu'), $('#menu-main-menu-1'), $('#menu-footer-menu')], i, $mnu, $li, found,
			current 		= 'current-menu-item',
			unselected  	= 'state-all-unselected';

		for( i=0; i<menus.length; i++ ){
			$mnu = menus[i];
			$li = $mnu.find( 'li' );
			found = false;

			// reset
			$li.removeClass( current ).removeClass( unselected );
			// find which one if selected
			$li.each( function(){
				if ( $(this).find( 'a' ).attr( 'href' ) === url ){
					$(this).addClass( current );
					found = true;
				}
			});
			// if there is no selection -> unselected ( only for main menu's )
			if ( !found && i < 2 ){
				$li.addClass( unselected );
			}
		}

		// special cases ( mostly single templates, taxonomies and categories, sub-pages )
		// portfolio
		if ( this.$body.hasClass( 'single-project' ) || this.$body.hasClass( 'page-template-portfolio' ) || this.$body.hasClass( 'tax-project_category' ) ){
			this.setMenuSelection( 0, current, unselected );
		}
		// profile
		else if ( this.$body.hasClass( 'parent-pageid-9' ) || this.$body.hasClass( 'single-people' ) ){
			this.setMenuSelection( 2, current, unselected );
		}
		// news
		else if ( this.$body.hasClass( 'single' ) || this.$body.hasClass( 'page-template-news' ) || this.$body.hasClass( 'category' ) ){
			this.setMenuSelection( 3, current, unselected );
		}

	}

	setMenuSelection( index, current, unselected ){
		let menus = [$('#menu-main-menu'), $('#menu-main-menu-1')], $mnu, $li, i;
		for( i=0; i<menus.length; i++ ){
			$mnu = menus[i];
			$li = $mnu.find( 'li' );
			// reset
			$li.removeClass( unselected );
			// set
			$mnu.find( 'li:eq(' + index + ')' ).addClass( current );
		}		
	}


	//----------------------------------------------------------- MOBILE ---------------------------------------//
	initMobile(){
		$('#burger-mobile').on( 'tap', 			()=>this.openDrawerMobile(true) );
		$('#drawer-mobile .close.icon').on( 'tap', 	()=>this.openDrawerMobile(false) );

		// ADD item Lawns
		$('#drawer-mobile .drawer-main-menu').append( '<li><a href="#" class="open-lawns-mobile">' + $('#desktop-header .widget-weather a.open-lawns-drawer').text() + '</a></li>' );
		$('#drawer-mobile a.open-lawns-mobile').on( 'click', (e)=>this.openMobileLawns(true,e) );

		this.initMobileSearch();

		//this.openDrawerMobile( true );
	}
	openDrawerMobile( b ){
		if ( b ){
			if ( !this.$body.hasClass( 'drawer-mobile-open') ){
				this.$body.addClass( 'drawer-mobile-open' );
				disableBodyScroll( $('#drawer-mobile .scroll-drawer')[0] );
			}
		}
		else{
			if ( this.$body.hasClass( 'drawer-mobile-open') ){
				this.$body.removeClass( 'drawer-mobile-open' );
				enableBodyScroll( $('#drawer-mobile .scroll-drawer')[0] );
			}
		}
	}
	initMobileSearch(){
		let $s = $('#drawer-mobile .search'), $input = $('#drawer-mobile .searchfield');
		$s.on( 'click', ()=>{
			$('#drawer-mobile').addClass( 'activate-search' );
			$input.focus();
		});
		$input.on( 'blur', ()=>{
			$('#drawer-mobile').removeClass( 'activate-search' );
		})
	}
	openMobileLawns(b,e){
		if  ( e ){
			e.preventDefault();
		}
		if ( b ){
			this.openDrawerMobile( false );
		}
		this.openLawns(b)
	}


	resetMobileMenu(){
		let $li, $a;
		$('#menu-mobile-menu > li').each((i,el)=>{
			$li = $(el);
			if ( $li.hasClass( 'menu-item-has-children' ) ){
				$a = $li.find( '> a' );
				if ( $a.data( 'open') ){
					$a.click();
				}
			}
		});
		$('#scroll-panel').scrollTop(0);	
	}

 	checkHash(){
 		let hash = document.location.hash, $a;

 		if ( hash ){

 			// anchors (https://mspc.local/support/other-ways-to-give/#park-dedications)
 			$a = $( hash );
 			if ( $a.length > 0 ){
 				if ( $a.hasClass( 'anchor' ) ){
 					this.scrollToHash( $a );
 					return;
 				}
 			}

 			// menus
 			hash = hash.substring(1).replace( /-/g , ' ');
 			$a = $('#' + hash );
 			if ( $a.length > 0 ){
 				if ( $a.attr( 'name') === hash ){
 					this.scrollToHash( $a );
 				}
 			} 

 		}
 	}

 	scrollToHash( $el ){
 		gsap.to( $(window), {duration: 0.8, scrollTo: { y : $el[0], offsetY: 60 }, delay: 0.4, ease: 'power.easeOut' });
 	}


	onBarbaChangeState( state, data ){
		switch ( state ){
			case 'before':
				this.openLawns( false );
				this.openDrawer( false );
				this.openDrawerMobile( false );
				break;
			case 'beforeEnter':
				this.paintMenu( data.next.url.href );
				this.changePageTitle();
				this.onResize();
				break;
			case  'after':
				this.checkHash();
				break;
		}
	}

}

